import moment from 'moment';

import { NewsCard } from 'hb-react/frontoffice/apps/NewsIndex/components/NewsCard';
import { NewsCardPinned } from 'hb-react/frontoffice/apps/NewsIndex/components/NewsCardPinned';

import type { MakeItemRendererArgs, NewsItem } from './types';

export const makeItemRenderer =
  ({
    fallbackCoverPicture,
    navigate,
    pinned,
    topicId,
    whitelabelURL,
  }: MakeItemRendererArgs) =>
  ({
    item: {
      content,
      feedableAt,
      id,
      newCoverPicture,
      publishedAt,
      seoDescription,
      seoTitle,
      subject,
    },
  }: {
    item: NewsItem;
  }) => {
    const linkPath =
      topicId && !whitelabelURL
        ? Routes.topic_new_path(topicId, id)
        : Routes.new_json_path(id);

    const onClick = () => {
      navigate(linkPath);
    };

    const date = feedableAt
      ? moment(feedableAt).format('LL')
      : moment(publishedAt).format('LL');

    return pinned ? (
      <NewsCardPinned
        coverPicture={newCoverPicture.previewUrl}
        fallbackCoverPicture={fallbackCoverPicture}
        key={id}
        onClick={onClick}
        subject={seoTitle || subject}
      />
    ) : (
      <NewsCard
        coverPicture={newCoverPicture.previewUrl}
        description={seoDescription || content}
        fallbackCoverPicture={fallbackCoverPicture}
        key={id}
        onClick={onClick}
        publishedAt={date}
        subject={seoTitle || subject}
      />
    );
  };
